import { render } from "@testing-library/react";
import React from "react";
import {BrowserRouter, Routes, Route, Redirect} from 'react-router-dom';
import Cart from "../pages/Cart";
import { publicRoutes } from "../routes";
const AppRouter = () => {
    
    return (

            <Routes>
            {publicRoutes.map(
                ({path, Component}) => <Route key={path} path={path} element={Component} exact/>
            )}
            </Routes>

    );

}

export default AppRouter;

